<template>
  <div> 
  <newUser  v-if='$route.params.tasktype === "newUser"' :userID='$route.params.id' :taskID="$route.params.taskId" />
  <newFileUpload v-if='$route.params.tasktype === "newFileUpload"' />
  
  </div>
</template>

<script>
import newFileUpload from "../components/myTasks/newFile"
import newUser from "../components/myTasks/newUser"
export default {
     components : {
        newUser,newFileUpload
    },
    mounted() {
      
    },
    methods : {
        removeTask(){

        }
    }
}
</script>
